import React, { useContext, useState } from "react";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";
import ReactDatePicker from "react-datepicker";
import * as CONST from "../../../helpers/Constants";

const Cancel = ({ formHandler, taskId }) => {
  const [subStatusId, setSubStatusId] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [showDateSelector, setShowDateSelector] = useState(false);
  const settings = useContext(Settings);
  const [canceled, setCanceled] = useState(false);

  return (
    <>
      {!canceled && <a onClick={() => setCanceled(true)}>Cancel appointment</a>}
      {canceled && (
        <div className="mt20">
          <b>Tell Us Why</b>

          <select
            className="cpr-form"
            value={subStatusId}
            onChange={(e) => {
              setSubStatusId(e.target.value);
              let label = settings.appointment_status_options.find((el) => el.id == e.target.value).label;
              if (CONST.SUB_STATUSES_SHOW_DUE_DATE_SELECTOR.includes(label)) {
                setShowDateSelector(true);
              } else {
                setShowDateSelector(false);
              }
            }}
          >
            <option value="">{"Select an option"}</option>
            {settings.appointment_status_options.map((i) => (
              <option key={i.value} value={i.id}>
                {i.label}
              </option>
            ))}
          </select>
          {
            showDateSelector && (
              <>
                <label>Select a due date (optional)</label>
                <ReactDatePicker
                  className="date-picker-selector"
                  autoComplete="off"
                  minDate={new Date()}
                  selected={dueDate}
                  placeholder="Select a Date"
                  dateFromat={"YYYY-MM-dd"}
                  onChange={(date) => {
                    setDueDate(date);
                  }}
                />
              </>
            )
          }
          <br className="m-t-lg" />
          {subStatusId && (
            <span>
              <b className="m-t-lg primary-accent"> {"Click Check to Submit & Cancel Appointment"}</b>
            </span>
          )}

          <div className="check-cancel-buttons">
            {subStatusId && (
              <>
                <button
                  className="check small"
                  onClick={() => {
                    formHandler({
                      task: {
                        id: taskId,
                        due_date: dueDate,
                        sub_status_list_id: subStatusId,
                        appointment_request_status: "appointment_not_completed",
                        priority: null,
                        status: "closed",
                      },
                    });
                  }}
                >
                  <MdCheck className="check-icon" />
                </button>
              </>
            )}{" "}
            <button className="cancel small" onClick={(e) => canceled && setCanceled(false)}>
              <MdClose className="cancel-icon" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Cancel;
